import { Radio } from "@base-ui/react/radio";
import { RadioGroup } from "@base-ui/react/radio-group";
import { ThumbsDownIcon, ThumbsUpIcon } from "lucide-react";
import { Controller, useFormContext } from "react-hook-form";
import ExtendedImage from "@/components/ui/extended-image";
import type { Question } from "@/types/content";

const TrueFalseQuestion = ({ question }: { question: Question }) => {
  const { control } = useFormContext();
  return (
    <div className="flex flex-col gap-4">
      <div className="relative w-full aspect-video">
        <ExtendedImage
          alt={question.id}
          className="rounded-2xl max-h-96 aspect-video"
          fill={true}
          src={question.image}
        />
      </div>
      <p className="leading-5 font-medium">{question.text}</p>
      <Controller
        control={control}
        defaultValue=""
        name={question.id}
        render={({ field }) => {
          return (
            <RadioGroup
              aria-labelledby={question.id}
              className="flex flex-row items-center justify-center gap-1"
              onValueChange={field.onChange}
            >
              {question.options.map((option, index) => (
                <label
                  className="flex items-start justify-between border border-gray-300 rounded-xl px-4 py-2 w-60 gap-2"
                  htmlFor={option.id}
                  key={option.id}
                >
                  <div className="flex flex-col gap-2 py-8 mx-auto">
                    {index === 0 ? (
                      <ThumbsUpIcon className="size-12 stroke-brand-blue-600" />
                    ) : (
                      <ThumbsDownIcon className="size-12 stroke-brand-blue-600" />
                    )}
                    <span className="text-sm leading-5 font-bold text-neutral-800">
                      {option.label}
                    </span>
                  </div>
                  <Radio.Root
                    className="flex size-5 items-center justify-center rounded-full focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-800 data-checked:bg-white data-checked:border data-checked:border-brand-blue-600 data-unchecked:border data-unchecked:border-gray-300"
                    id={option.id}
                    value={option.id}
                  >
                    <Radio.Indicator className="flex before:size-3 before:rounded-full before:bg-brand-blue-600 data-unchecked:hidden" />
                  </Radio.Root>
                </label>
              ))}
            </RadioGroup>
          );
        }}
      />
    </div>
  );
};

export default TrueFalseQuestion;
